"use client";
import React, { memo, useEffect } from "react";
import {} from "@/lib/commonService";
import { performanceRecord } from "@/src/models/common";

interface IProps {
    mountType: number;
}

const ISMOBILE = 1;

const SsrPerformanceRecord = memo(({ mountType }: IProps) => {
    useEffect(() => {
        const url = new URL(window.location.href);
        const requestUrl = url.pathname;
        const requestTimeCount =
            window.performance.timing.responseEnd -
            window.performance.timing.fetchStart;
        if (requestTimeCount > 0) {
            performanceRecord({
                clientType: ISMOBILE,
                requestType: 0,
                requestTimeCount,
                requestUrl,
                mountType,
            } as any);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
});

SsrPerformanceRecord.displayName = "SsrPerformanceRecord";

export default SsrPerformanceRecord;
